import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

import { TipoCondicionDTO } from "app/main/apps/shared/interfaces/tipo-condicion.interface";
import { DetalleServicioSeleccionado } from "app/main/apps/shared/models/detalle-servicio-seleccionado.model";
import { CodigosService } from "app/main/apps/shared/services/rest/codigos.service";
import { ServicioDTO } from "app/main/apps/shared/interfaces/servicio.interface";
import { Subscription } from "rxjs";

import { fuseAnimations } from "@fuse/animations";
import { ValidadoresFormularioService } from "app/main/apps/shared/services/util/validadores-formulario.service";

interface DialogData {
    servicio: ServicioDTO;
    editar: boolean;
    detalle: DetalleServicioSeleccionado;
}

@Component({
    selector: "app-dialog-agregar-servicio",
    templateUrl: "./dialog-agregar-servicio.component.html",
    styleUrls: ["./dialog-agregar-servicio.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class DialogAgregarServicioComponent implements OnInit {
    formAgregarServicio: FormGroup;
    condiciones: TipoCondicionDTO[] = [];
    largoMaximo = 500;
    subscripciones: Subscription;
    constructor(
        public dialogRef: MatDialogRef<DialogAgregarServicioComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private fb: FormBuilder,
        private _codigosSrvc: CodigosService,
        private customValidators: ValidadoresFormularioService
    ) {}

    ngOnInit(): void {
        //console.log("oasdi");
        //this._fuseProgressBarService.show();

        this._codigosSrvc.fetchCondicionesServicio().subscribe((resp) => {
            this.condiciones = resp;
        });
        console.log(this.customValidators.regexSoloNumerosYPunto);

        this.initForm();
    }

    initForm() {
        this.formAgregarServicio = this.fb.group({
            cantidad: [this.data.detalle?.cantidad || null],
            tiempo: [this.data.detalle?.tiempo || null],
            condicion: [
                this.data.detalle?.condicion || null,
                { validators: [Validators.required] },
            ],
            observacion: [
                this.data.detalle?.observacion || "",
                { validators: [Validators.maxLength(500)] },
            ],
        });

        if (this.data.servicio.unidadMedida) {
            this.cantidad.setValidators([
                Validators.required,
                Validators.min(0),
                Validators.max(50000000),
                Validators.pattern(
                    this.customValidators.regexSoloNumerosYPunto
                ),
            ]);
        }

        if (this.data.servicio.unidadTiempo) {
            this.tiempo.setValidators([
                Validators.required,
                Validators.min(0),
                Validators.max(50000000),
                Validators.pattern(this.customValidators.regexSoloNumeros),
            ]);
        }
    }

    get cantidad() {
        return this.formAgregarServicio.get("cantidad");
    }
    get condicion() {
        return this.formAgregarServicio.get("condicion");
    }
    get observacion() {
        return this.formAgregarServicio.get("observacion");
    }

    get tiempo() {
        return this.formAgregarServicio.get("tiempo");
    }

    cerrar(): void {
        this.dialogRef.close();
    }
}
